import { useNavigation } from "@react-navigation/native";
import {
  Button,
  HStack,
  Text,
  VStack,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useSendToRetailer } from "./hooks";

export interface ProductImageDetailsScreenFooterProps {
  productId: string;
  selected: string[];
}

export function ProductImageDetailsScreenFooter({
  productId,
  selected,
}: ProductImageDetailsScreenFooterProps) {
  const { navigate } = useNavigation<any>();
  const { spacings } = useThemeProvider();

  const { handleSendToRetailer, sendProgress, loading } = useSendToRetailer();

  function openDeleteModal() {
    navigate("ProductImageDeleteScreen", {
      imageIds: selected,
    });
  }

  const sendLabel = sendProgress
    ? `Sending ${sendProgress.completed}/${sendProgress.total}...`
    : "Send to Retailer";

  return (
    <VStack spacing={spacings.s2}>
      {sendProgress && (
        <Text variant="heading5" color="subdued" style={{ textAlign: "center" }}>
          Sending image {sendProgress.completed + 1} of {sendProgress.total}
        </Text>
      )}
      <HStack spacing={spacings.s3}>
        <Button
          label={sendLabel}
          isAction
          disabled={!selected.length || loading}
          onPress={() =>
            handleSendToRetailer({ productId: productId, imageIds: selected })
          }
          style={{ display: "flex", flexGrow: 1, flexShrink: 0 }}
        />
        <Button
          label="Delete"
          isDestructive
          disabled={!selected.length || loading}
          onPress={openDeleteModal}
          style={{ display: "flex", flexGrow: 1, flexShrink: 0 }}
        />
      </HStack>
    </VStack>
  );
}